import instance from '@/api/business';
import { NonResearchReason } from '@/types/NonResearchReason';
import {
  CreateNonResearchReasonPayload,
  DeleteNonResearchReasonPayload,
  UpdateNonResearchReasonPayload,
} from './type';

const BASE_URL = '/marketresearch/im/non-research-reason';

export const fetchNonResearchReason = async (onlyActive?: boolean) => {
  const response = await instance.post<NonResearchReason[]>(BASE_URL, {
    onlyActive,
  });
  return response.data;
};

export const createNonResearchReason = async (
  data: CreateNonResearchReasonPayload
) => {
  const response = await instance.put(BASE_URL, data);
  return response.data;
};

export const updateNonResearchReason = async (
  data: UpdateNonResearchReasonPayload
) => {
  const response = await instance.patch(BASE_URL, data);
  return response.data;
};

export const deleteNonResearchReason = async (
  data: DeleteNonResearchReasonPayload
) => {
  const response = await instance.delete(BASE_URL, {
    data,
  });
  return response.data;
};
